import { render, staticRenderFns } from "./IconEuro.vue?vue&type=template&id=2fc559fe&"
import script from "./IconEuro.vue?vue&type=script&lang=ts&"
export * from "./IconEuro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports